import React from 'react';

import { DebugPanel } from 'components/dev/DebugPanel';

import { getImageDataUsingCanvas } from './qrCodeScannerUtils';

/** To debug QR sync more easily, we can upload screenshots on Dev */
export default function QrCodeScannerDevInput({
  onImageData,
}: {
  onImageData: (data: ImageData) => void;
}) {
  return (
    <DebugPanel>
      <input
        type="file"
        onChange={image => {
          const fileBlob = image.target.files?.[0];
          if (!fileBlob) {
            return;
          }
          const img = new Image();
          img.onload = function () {
            const imageData = getImageDataUsingCanvas({
              source: img,
              width: img.width,
              height: img.height,
            });
            if (imageData) {
              onImageData(imageData);
            }
          };
          img.src = URL.createObjectURL(fileBlob);
        }}
        className="filetype"
      />
    </DebugPanel>
  );
}
